<template>
  <div id="User_Fields_Table">
    <a-divider style="font-size:1.5rem;" orientation="left">{{$t('Fields')}}</a-divider>
    <p>{{$t('User_Fields_Table_text')}}</p>
    <a-table :columns="columns" :data-source="userFieldsCompany" :pagination="false" bordered>
      <template slot="status" slot-scope="text, record">
        <a-icon v-if="record.status" type="check" style="color:green" />
        <a-icon v-else type="close" style="color:red" />
      </template>
      <template v-for="col in ['userField']" :slot="col" slot-scope="text, record">
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :placeholder="$t('New field label')"
            @change="e => handleChange(e.target.value, record.key, col,false)"
          />
          <a-select
            v-else
            :default-value="text"
            @change="e => handleChange(e, record.key, col,true)"
            style="width:100%"
          >
            <a-select-option v-for="i in selectOptionCompanyFields" :key="i.id">{{i.name}}</a-select-option>
          </a-select>
        </div>
      </template>

      <template slot="rootField" slot-scope="text">{{$t(text)}}</template>

      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a-popconfirm :title="$t('Sure to save?')" @confirm="() => save(record.key)">
              <a>{{$t('Save')}}</a>
            </a-popconfirm>
            <a @click="() => cancel(record.key)">{{$t('Cancel')}}</a>
          </span>
          <span v-else>
            <a :disabled="editingKey !== ''" @click="() => edit(record.key)">{{$t('Edit')}}</a>
          </span>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["allOptionCompanyFields"],
  data() {
    const columns = [
      {
        title: this.$t("Status"),
        dataIndex: "status",
        align: "center",
        width: "10%",
        scopedSlots: { customRender: "status" },
      },
      {
        title: this.$t("Field"),
        dataIndex: "rootField",
        width: "40%",
        scopedSlots: { customRender: "rootField" },
      },
      {
        title: this.$t("Company field"),
        dataIndex: "userField",
        width: "40%",
        scopedSlots: { customRender: "userField" },
      },
      {
        title: this.$t("Actions"),
        dataIndex: "operation",
        align: "center",
        scopedSlots: { customRender: "operation" },
      },
    ];
    return {
      userFieldsCompany: [],
      columns,
      editingKey: "",
      editingValue: "",
    };
  },
  computed: {
    selectOptionCompanyFields() {
      let listIDfields = [];
      for (let i in this.settingsNip) {
        listIDfields.push(this.settingsNip[i].id);
      }
      var res = this.allOptionCompanyFields.filter(
        (x) => !listIDfields.includes(x.id)
      );

      return res;
    },
    ...mapGetters(["settingsNip"]),
  },
  methods: {
    ...mapActions(["BXsetSettingsApp"]),
    handleChange(value, key, column, flagSelect) {
      const newData = [...this.userFieldsCompany];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.editingValue = value;
        target["status"] = true;
        this.userFieldsCompany = newData;
        let userfield = this.allOptionCompanyFields.find(
          (x) => x.id == target.userField
        );
        if (flagSelect) {
          this.updateSettings(target.rootField, userfield.id, userfield.name);
        }
      }

    },
    edit(key) {
      const newData = [...this.userFieldsCompany];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.userFieldsCompany = newData;
      }

    },
    save(key) {
      const newData = [...this.userFieldsCompany];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      //TODO error form empty userfield

      if (target && targetCache && target.userField) {
        delete target.editable;
        this.userFieldsCompany = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
        this.CreateUserfield(target.rootField, this.editingValue);
      } else {
        this.$notification.error({
          message: this.$t("Input Error"),
          placement: "bottomRight",
        });
      }
      this.editingKey = "";

    },
    cancel(key) {
      const newData = [...this.userFieldsCompany];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.userFieldsCompany = newData;
      }
    },
    CreateUserfield(keyUpdate, title) {
      var IdCode = "NIP_APP_" + Date.now();
      BX24.callMethod(
        "crm.company.userfield.add",
        {
          fields: {
            FIELD_NAME: IdCode,
            EDIT_FORM_LABEL: title,
            LIST_COLUMN_LABEL: title,
            USER_TYPE_ID: "string",
            XML_ID: IdCode,
          },
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.updateSettings(keyUpdate, "UF_CRM_" + IdCode, title, true);
          }
        }
      );
    },
    updateSettings(keyUpdate, id, name, flagCreate) {
      let pastName = this.settingsNip[keyUpdate]?.name ?? "";
      this.settingsNip[keyUpdate] = { id, name };
      this.BXsetSettingsApp(this.settingsNip);
      let config = flagCreate
        ? {
            message: "Creation and Saving Successful",
            description: `Field ${pastName} replaced by ${name}.`,
            placement: "bottomRight",
          }
        : {
            message: "Saving Successful",
            description: `${name} field has been created and replaced instead of the ${pastName}.`,
            placement: "bottomRight",
          };
      this.$notification.success(config);
    },
  },
  mounted() {
    let userFields = [
      {
        key: 1,
        status: false,
        rootField: "NIP",
      },
      {
        key: 2,
        status: false,
        rootField: "COUNTRY",
      },
      {
        key: 3,
        status: false,
        rootField: "CITY",
      },
      {
        key: 4,
        status: false,
        rootField: "ADDRESS_1",
      },
      {
        key: 5,
        status: false,
        rootField: "ADDRESS_2",
      },
      {
        key: 6,
        status: false,
        rootField: "POSTAL_CODE",
      },
    ];
    let flag = [];
    for (let [key, value] of Object.entries(userFields)) {
      if (
        this.settingsNip[value.rootField] &&
        this.settingsNip[value.rootField].name
      ) {
        userFields[key]["userField"] = this.settingsNip[value.rootField].name;
        userFields[key]["status"] = true;
      } else {
        flag.push(this.$t(value.rootField));
        userFields[key]["userField"] = "";
      }
    }
    if (flag.length)
      this.$warning({
        title: this.$t("You need to fill in the fields of the table"),
        content: flag.toString(),
      });
    this.userFieldsCompany = userFields;
    this.cacheData = this.userFieldsCompany.map((item) => ({ ...item }));
  },
};
</script>

<style scoped>
.col_text {
  text-align: center;
}
.editable-row-operations a {
  margin-right: 8px;
}
</style>
